const BidAmountChecker = require('./bid_amount_checker.js');
const Countdown = require('./countdown.js');

var placeButton = 'a[data-bind=\'place-bid\']';
var placeBidForm = '#place-bid-form';
var bidInput = 'input[name=\'max_bid\']';

function showBiddingLightbox(e) {
  e.preventDefault();
  Reverb.UI.Ajax.lightbox(dialogFetchUrl(), lightboxCallbacks);
}

function lightboxCallbacks() {
  BidAmountChecker.checkBidAmount();
  Countdown.init();
}

function bindPlaceBid() {
  $(document).on('submit', placeBidForm, showBiddingLightbox);
  $(document).on('click', placeButton, showBiddingLightbox);
}

function dialogFetchUrl() {
  return $(placeButton).prop('href') + bidProperty();
}

function bidProperty() {
  return inputBidValue() ? ('?bid=' + inputBidValue()) : '';
}

function inputBidValue() {
  return $(bidInput).val();
}

function init(options) {
  bindPlaceBid();
}

module.exports = {
  init,
};



// WEBPACK FOOTER //
// ./javascripts/components/legacy/auctions/bid_placement.js